// extracted by mini-css-extract-plugin
module.exports = {"submenu":"Submenu_submenu__3Kczy","main":"Submenu_main__2VsUQ","link-container":"Submenu_link-container__ub1Rn","active-link":"Submenu_active-link__1-GgQ"};